import React from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import Select from "react-select";

export const FormInputSelect = ({
  name,
  options,
  handleChange,
  styles,
  setValue,
  placeholder,
  className,
  rules = {},
  selectClassNames = {},
  components = {}
}) => {
  const form = useFormContext();
  const { control } = form;

  let selectedValue = useWatch({
    control,
    name
  });

  if (name === "departure_date") {
    // formate date value for match date options.
    selectedValue = selectedValue.replace(/ {2}/g, " ");
    selectedValue =
      selectedValue.charAt(0) === "0"
        ? selectedValue.substring(1)
        : selectedValue;
  }

  const handleMenu = (event) => {
      setValue(name, event.value);
      if (typeof handleChange === "function") handleChange(event);
    };
  const formatOptionLabel = ({ label, value }) => (
    <div dangerouslySetInnerHTML={{ __html: label }}></div>
  );
  return (
    <>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={() => (
          <Select
            options={options}
            value={
              selectedValue
                ? options.find((c) => c.value === selectedValue)
                : selectedValue
            }
            onChange={handleMenu}
            className={className}
            styles={styles}
            classNames={selectClassNames}
            placeholder={placeholder}
            components={components}
            formatOptionLabel={formatOptionLabel}
          />
        )}
      />
    </>
  );
};
